import createStyled from "../createStyled/index.js";
var styled = createStyled();
export default styled;
